import cmfApi from "../index";

const API_URL = "/stats/top/territories";

function getTop(token, filters) {
	const config = {
		headers: {
			Accept: "application/json",
			Authorization: `Bearer ${token}`,
		},
		params: filters
	};

	const URL = API_URL

	return new Promise(function (resolve, reject) {
		cmfApi.get(URL, config).then(
			(response) => {
				var result = response.data;
				resolve(result);
			},
			(error) => {
				reject(error);
			}
		);
	});
}

export { getTop };
